//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';



//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

const iInitial = {
    open:false,
    data:{}
}

export const playGameModal = (state = iInitial, action) => {
    switch (action.type) {
        case ActionTypes.game.set_player_modal:
            return action.payload;
        default:
            return state;
    }
}
const iModalInitial = {
    open:false,
    iframeUrl:''
}
export const oneGameModal = (state = iModalInitial, action) => {
    switch (action.type) {
        case ActionTypes.game.set_one_game_modal:
            return action.payload;
        default:
            return state;
    }
}
const initalGame = []
export const class_game_activity = (state = initalGame, action) => {
    switch (action.type) {
        case ActionTypes.game.set_class_game_activity:
            return action.payload;
        case ActionTypes.game.update_class_game_activity:
            return state.map((item) => {
                if (item.id === action.payload.id) {
                    return { ...item, ...action.payload };
                }
                return item;
            });
        case ActionTypes.game.clear_class_game_activity:
            return initalGame;
        case ActionTypes.game.list_class_game_activity_for_student_with_ids:
            if(action.payload?.isDeleted){
                const { activityIds } = action.payload;
                if(activityIds?.length > 0){
                    return state.filter(data => !activityIds.includes(data?.activityId));
                }
                return state;
            }
            const haveSome = state.some(data => data?.id === action.payload?.id);
            if(haveSome){
                return state.map(data => {
                    if(data?.id === action.payload?.id){
                        return action.payload;
                    }
                    return data;
                });
            }else{
                const newData = [...state, action.payload];
                return newData;
            }
        default:
            return state;
    }
}